import { render, staticRenderFns } from "./PlanejamentoContratoFormRodape.vue?vue&type=template&id=5a036bb3&"
import script from "./PlanejamentoContratoFormRodape.vue?vue&type=script&lang=js&"
export * from "./PlanejamentoContratoFormRodape.vue?vue&type=script&lang=js&"
import style0 from "./PlanejamentoContratoFormRodape.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBtn,VCol,VContainer,VDivider,VRow,VStepper,VStepperHeader,VStepperStep})
